import {Box, Skeleton, Stack} from '@mui/material';
import {CardCollapse} from '../../shared/card-collapse';

export const HeaderSkeleton = ({defaultExpand}: {defaultExpand: boolean | undefined}) => {
  return (
    <CardCollapse
      key="empty_card_collapse"
      collapsableHeader={
        <Stack gap={2} flexDirection="row" alignItems="center">
          <Skeleton
            animation="wave"
            variant="rounded"
            sx={{
              height: '50px',
              width: '50px',
              borderRadius: '100%',
            }}
          />
          <Stack gap={1} flexDirection="column">
            <Skeleton
              animation="wave"
              variant="rounded"
              sx={{
                height: '20px',
                width: '140px',
                borderRadius: '5px',
              }}
            />
            <Skeleton
              animation="wave"
              variant="rounded"
              sx={{
                height: '20px',
                width: '80px',
                borderRadius: '10px',
              }}
            />
          </Stack>
        </Stack>
      }
      cardProps={{
        className: 'task-details-card',
      }}
      isLoading
      defaultExpand={defaultExpand}
    >
      <></>
    </CardCollapse>
  );
};

export const CardSkeleton = () => {
  return (
    <>
      <Box
        className="task-details-card-content"
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: {xs: '10px 32px', sm: '32px 150px'},
          padding: {
            xs: 0,
            sm: '0 0 10px 0',
          },
        }}
      >
        {new Array(4).fill(1).map((_item, index) => (
          <Stack flexDirection="column" gap="8px" key={`grid_item_skeleton_${index}`}>
            <Skeleton
              animation="wave"
              variant="rectangular"
              sx={{
                height: '20px',
                width: '50%',
                borderRadius: '10px',
              }}
            />
            <Skeleton
              animation="wave"
              variant="rectangular"
              sx={{
                height: '20px',
                width: '100%',
                borderRadius: '10px',
              }}
            />
          </Stack>
        ))}
      </Box>
      <Stack
        className="task-details-card-content"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
          padding: '32px 10px 10px 0',
        }}
      >
        <Stack flexDirection="column" gap="8px">
          <Skeleton
            animation="wave"
            variant="rectangular"
            sx={{
              height: '20px',
              width: '12.5%',
              borderRadius: '10px',
            }}
          />
          <Skeleton
            animation="wave"
            variant="rectangular"
            sx={{
              height: '20px',
              width: '25%',
              borderRadius: '10px',
            }}
          />
        </Stack>
        <Stack flexDirection="column" gap="8px">
          <Skeleton
            animation="wave"
            variant="rectangular"
            sx={{
              height: '20px',
              width: '12.5%',
              borderRadius: '10px',
            }}
          />
          <Skeleton
            animation="wave"
            variant="rectangular"
            sx={{
              height: '20px',
              width: '50%',
              borderRadius: '10px',
            }}
          />
        </Stack>
      </Stack>
    </>
  );
};
